import { schoolService } from "@/services/api/features/schoolService";
import { executeAction } from "@/services/api/helpers";

const schoolModules = {
  namespaced: true,

  state: () => ({
    loading: {},
    error: {},
    schoolList: [],
    classList: [],
  }),

  getters: {
    getSchoolList: (state) => state.schoolList,
    getClassList: (state) => state.classList,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },

  mutations: {
    SET_SCHOOL: (state, list) => (state.schoolList = list),
    SET_CLASS: (state, list) => (state.classList = list),
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },
  actions: {

    // -----------   School And Class Modules -------------  

    async getSchoolList({ commit }) {
      return executeAction(
        { commit, action: "getSchoolList" },
        () => schoolService.getSchoolList(),
        { success: (data) => commit("SET_SCHOOL", data?.data) }
      );
    },

    async getSchoolById({ commit }, id) {
      return executeAction({ commit, action: "getSchoolById" }, () =>
        schoolService.getSchoolById(id)
      );
    },

    async getClassList({ commit }) {
      return executeAction(
        { commit, action: "getClassList" },
        () => schoolService.getClassList(),
        { success: (data) => commit("SET_CLASS", data?.data) }
      );
    },

    async getClassById({ commit }, id) {
      return executeAction({ commit, action: "getClassById" }, () =>
        schoolService.getClassById(id)
      );
    },
  },
};

export default schoolModules;
